import { useMemo } from 'react'
import { Alert, Typography } from '@mui/material'
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-pro'

import SimpleTable from '../simple-table'

const ReturnDevicesTable = ({ expandedDetails }: { expandedDetails: IReturnDetail }) => {
  const { devices, disposition } = expandedDetails

  const columns = [
    {
      field: 'device',
      headerName: disposition === 'scrap' ? 'Devices Being Scrapped' : 'Devices Being Returned',
      flex: 3,
      sortable: false,
      renderCell: (params: GridRenderCellParams) => (
        <Typography
          sx={{
            paddingY: 2,
          }}
        >
          {params.value}
        </Typography>
      ),
    },
  ] satisfies GridColDef[]

  const rows = useMemo(
    () =>
      devices.map((d, idx) => ({
        id: idx,
        device: d.uniqueId,
      })),
    [devices]
  )

  if (rows.length === 0)
    return (
      <Alert severity="error" sx={{ marginTop: 2 }}>
        No devices found
      </Alert>
    )
  return <SimpleTable columns={columns} rows={rows} />
}

export default ReturnDevicesTable
